/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import type { ZnFacet, ZnFacetItem } from '~/types/filter'

export const FILTERS_ARRAY = [
  'gender',
  'Frame___Prescription_types_search',
  'price',
  'Frame___Features_search',
  'size',
  'frameStyle',
  'color',
  'brand',
  'material',
  'Frame___Size_search',
  'Main_Color_search',
  'Frame___Shape_search',
  'frame_gender',
  'Frame___Gender_search',
  'Brand_search',
  'Frame___Material_search',
  'Frame___Rim_type_search',
  'Price_search',
  'categories',
  'Is_Under_25_Limit',
  'Is_Under_50_Limit',
  'Is_Under_75_Limit',
  'Is_Under_100_Limit',
  'Is_Under_125_Limit',
  'Is_Under_150_Limit',
  'Is_Under_175_Limit',
  'Is_Under_200_Limit',
  'objectType',
] as const

export type Filters = (typeof FILTERS_ARRAY)[number]

export interface CheckboxItemProps {
  title: string
  facet?: ZnFacet
  selected: string[]
  filterOrder?: number
}

export interface CheckboxItemEmits {
  (event: 'update:selected', value: CheckboxItemProps['selected']): void
}

export interface ChipSelectorProps {
  title?: string
  facet?: ZnFacet
  selected: string[]
  filterOrder?: number
  labelOrder?: string[]
}

export type ChipSelectorEmits = (
  event: 'update:selected',
  parameter: ChipSelectorProps['selected'],
) => void

export const COLORS_WITH_BORDER = ['clear', 'white', 'azure']

export enum ZnColorDotSize {
  sm = 'sm',
  base = 'base',
  lg = 'lg',
  xl = 'xl',
}

export enum ZnColorDotMap {
  black = '#000',
  blue = '#092caa',
  brown = '#765d4b',
  clear = 'linear-gradient(225deg,#bed9ee 27.6%,rgba(224,236,240,0))',
  cream = '#e0d5be',
  gold = 'linear-gradient(220deg, #E1C13D 7.58%, #D6AA0E 100%)',
  gray = '#666',
  green = '#0caa09',
  multicolor = 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFDSURBVHgBpZK/SsNAAId/d006JBGsfyYRETehWBAEwcU38H3curUuGZRsBd9CcdBBfIlSRFxq6x9IcllMiHeJsWfSS0z9IIS7XD6+3IVMT0/ipZ1P/AcnbENjTzoazRjGZohF6IYHGES7oGLgDpvwRjrq4kTtRCLQsklRRrjW2v7bZ9pRB3bY+Rlr8kP/Ma2qkgmBEMnQ/CIhy4TKkpykUCTLCI1hbv0+gF64n+zLPCgUeCN+AMNZmdhUlURZlMGedVD+a5xv7JVKSosy+h8u+u64all5UXd9jEHrDQhe0CAWDOMQtYuclddU8o3LruCxG9Qqslen/JoU5llwD8JfsczjapEQCJEKP7hL7nkZLZaoJbLMZ7fzi3prE74v1RJZRogO0ziaFV0uv9eSZIjN9/zrtOiMl1y0uCTGQrDgAZSa+ALaUnmJ74U1/AAAAABJRU5ErkJggg==")',
  orange = '#FF9100',
  pattern = 'linear-gradient(219.81deg,#000 9.02%,#fff 24.91%,#000 38.87%,#fff 53.31%,#000 66.79%,#fff 80.26%,#000 92.78%)',
  pink = '#aa0987',
  purple = '#6D09AA',
  red = '#aa0909',
  rosegold = 'linear-gradient(225deg, #D7929C 0%, #AD717A 100%))',
  silver = 'linear-gradient(225deg,hsla(0,0%,40%,.19),#666)',
  tortoiseshell = 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGASURBVHgBlZM7S8NQGIbfkx57E4vVghdoqYMI4uCmUN0c+2/8A246i6s4OIvQVXBwFOziUorFqmmDbQyYGNM0NxNqT01TbPIMIXn5zsN3Ts5HNvOcA5eNwjyuTg4wRBBE8K13hIUbvnyqfRbquoFuV0IUmMg0bRYqyhf0voEoMNHSQoqFkiQjKkxUXJ1jYU/XERUmKpfyLDQME1Gh3mM9n8H+9soopBT9sTNSNBN1XoOmW0jGOSxmZrC2PDoOSghweljyLUolE0xUfVJwU5VQe/sOdJFzZVvFWZR3ciCV412nvFfwFbSFLuoNAWcVfqJgkpCOSzxi8TSOLp8hyuGugFdHhx89wwEvWlB1GxfXj+gof/5ECGjrw8JdTUdDMGG7w9J8beP+gR9IyG+VE0J0fqv6guZLO1gVQujr3ruIHfGfGSOTYxux0Rl5yLKKaVhkBqaTHDRIYq6EwkLCL9J600cjBhMaSbu79C31b43jCKbjII5g5z5RNptBGCi0QPYDmemPLl+D6P8AAAAASUVORK5CYII=")',
  white = '#fff',
  yellow = '#D6A908',
  'navy ombre' = '#0000FF',
  'classic tortoiseshell' = '#D2B48C',
  'pink tortoiseshell' = '#FFC0CB',
  'black pattern' = 'linear-gradient(219.81deg,#000 9.02%,#fff 24.91%,#000 38.87%,#fff 53.31%,#000 66.79%,#fff 80.26%,#000 92.78%)',
  azure = '#F0FFFF',
  blush = '#FFC0CB',
  buff = '#DAA06D',
  cherry = '#D2042D',
  'brown/blue' = '#0000FF',
  coral = '#FF7F50',
  cranberry = '#9F000F',
  'dark gray' = '#808080',
  emerald = '#50C878',
  floral = '#FF1493',
  graphite = '#383838',
  'ivory tortoiseshell' = '#FFBF00',
  'metallic blue' = '#32527B',
  midnight = '#191970',
  mist = '#FFE4E1',
  mulberry = '#770737',
  navy = '#000080',
  opal = '#A8C3BC',
  'polka dot' = '#0FF000',
  rainbow = 'linear-gradient(223.99deg,#eb0000 22.87%,#f90 35.24%,#f7ee19 45.97%,#65ed36 56.69%,#4ab7b0 67.83%,#0031e0 78.96%,#6200df 89.28%,#ce0090)',
  'rose gold' = '#B76E79',
  'sea glass' = '#00FFCD',
  serenity = '#9BC4E2',
  smoke = '#F5F5F5',
  storm = '#808080',
  teal = '#008080',
  'wine/rose ombre' = '#FFC0CB',
  woodtexture = 'url("data:image/png;base64,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")',
}

export type ZnColorDotMapType = keyof typeof ZnColorDotMap

export interface ZnColorDotProps {
  selected?: boolean
  color?: ZnColorDotMapType
  size?: keyof typeof ZnColorDotSize
  withoutBorder?: boolean
  customColor?: string
}

export interface ColorDotFacetItem extends Omit<ZnFacetItem, 'value'> {
  value: ZnColorDotMapType
}

export interface ColorDotFacet extends Omit<ZnFacet, 'values'> {
  values: ColorDotFacetItem[]
}

export interface ColorDotItemProps {
  title: string
  facet?: ColorDotFacet
  selected?: ZnColorDotMapType[]
  filterOrder?: number
}

export interface ColorDotItemEmits {
  (event: 'update:selected', value: ZnColorDotMapType[]): void
}

export type Filter = {
  [key in Filters]?:
    | CheckboxItemProps
    | ChipSelectorProps
    | ColorDotItemProps
    | any
} & {
  filterOrder?: number
  title?: string
  facet: ZnFacet
  labelOrder?: string[]
}

export type SelectedFilters = {
  [key in Filters]?: string[] | ZnColorDotMapType[]
}

export interface ZnFilterProps {
  filters?: Filter
  selectedFilters?: SelectedFilters
  loading?: boolean
  grouped?: string[]
  freeGlasses?: string[]
  hideFilters?: boolean
}

export interface ZnFilterChipValue {
  label: string
  value: string
  category?: string
  permanent?: boolean
}

export interface ZnFilterModalProps extends ZnFilterProps {
  isOpen: boolean
}
